<template>
    <Dialog v-model="visible" :title="title" :footer="false" :padding="0">
        <div class="w-full" style="height: calc(90vh - 50px)">
            <Main :info="info" v-if="visible"></Main>
        </div>
    </Dialog>
</template>
  
<script>
import Main from './main.vue'

export default {
    components: { Main },
    props: {
        // 弹窗开关
        value: {
            type: Boolean,
            default: false
        },
        // 弹窗标题
        title: {
            type: String,
            default: '位置信息',
        },
        // 数据
        info: {
            type: Object,
            default: () => {
                return {
                    longitude: '',
                    latitude: ''
                }
            }
        },
    },
    watch: {
        // 弹窗开关
        value: {
            handler(val) {
                this.visible = val;
            },
            immediate: true
        },
        visible(val) {
            this.$emit("input", val);
        }
    },
    data() {
        return {
            visible: false,
        }
    },
    methods: {},
}
</script>
  